<div [ngClass]="theme ? 'bg-light': 'bg-black'">
    <div style="float: right;font-size: 15px;padding: 10px 13px;align-items: center;display: flex; " >
        <label style="padding-right:5px;" >Default Setting</label>
        <input type="checkbox" (change)="changeSetting($event)" class="large" [(ngModel)]="disable" >
    </div>

    <div [ngClass]="disable ? 'disableClass' : 'enableClass'" >
        <div [ngClass]="disable ? 'disableClass' : 'enableClass'" class="d-flex flex-column mb-3 pt-3 mx-3">
            <label for="">Max DA <i class="bi bi-exclamation-circle-fill" triggers="mouseenter:mouseleave"
                    [ngbPopover]="lowdaDesc"></i></label>
            <input [ngClass]="disable ? 'nonClass' : 'enableClass'" type="number" [(ngModel)]="maxDA" class="max-da-input input col-2" min="0" max="30">
            <ng-template #lowdaDesc>
                <div class="d-flex align-items-center justify-content-center serp-score">
                    <p>Max domain authority : Websited below that threshold will be considered as weak.</p>
                </div>
            </ng-template>
        </div>
        <div [ngClass]="disable ? 'disableClass' : 'enableClass'" class="d-flex flex-column my-3 mx-3">
            <label for="">Domains to highlight (custom weak spots) <i class="bi bi-exclamation-circle-fill"
                    triggers="mouseenter:mouseleave" [ngbPopover]="lowdaCustomDomain"></i></label>
            <!-- <textarea class="form-control" [(ngModel)]="customDomain" style="overflow:auto;resize:none" rows="5"
            cols="10"></textarea> -->
    
            <!-- <div class="input-group mb-3">
                <span class="input-group-text" id="basic-addon3">https://example.com/users/</span>
                <input type="text" class="form-control" id="basic-url" aria-describedby="basic-addon3">
              </div> -->
            <div class="border border-gray rounded remove-outline">
                <input [ngClass]="disable ? 'nonClass' : 'enableClass'" class="border-0 rounded w-100" (keyup.enter)="addCustomDomain()"
                    (focusout)="addCustomDomain('focusOut')" type="text" placeholder="Add Domain(s)"
                    [(ngModel)]="customDomain" style="overflow:auto;resize:none;height: 28px;">
                <div class="">
                    <span [ngClass]="disable ? 'nonClass' : 'enableClass'" class="fs-13 m-1  btn btn-outline-primary"
                        *ngFor="let chip of settingObj.customDomain;let i = index">
                        {{chip}} <i class=" text-secondary bi bi-x-circle-fill" style="padding-left: 5px !important;"
                            (click)="removeChip(i,'customDomain')"></i>
                    </span>
                </div>
            </div>
            <ng-template #lowdaCustomDomain>
                <div class="d-flex align-items-center justify-content-center serp-score">
                    <p>Add domains (or subdomains) that you could easily outrank.
                        They'll appear as purple icons and considered weak spots.
                    </p>
                </div>
            </ng-template>
        </div>
        <div [ngClass]="disable ? 'disableClass' : 'enableClass'" class="d-flex flex-column my-3 mx-3">
            <label for="">My Sites <i class="bi bi-exclamation-circle-fill" triggers="mouseenter:mouseleave"
                    [ngbPopover]="mySites"></i></label>
            <!-- <textarea class="form-control" name="mySitess" [(ngModel)]="mySitess" style="overflow:auto;resize:none" rows="5"
            cols="10"></textarea> -->
            <div class="border border-gray rounded remove-outline">
                <input [ngClass]="disable ? 'nonClass' : 'enableClass'" class="border-0  rounded w-100" (keyup.enter)="addCustomSites()"
                    (focusout)="addCustomSites('focusOut')" type="text" placeholder="Add Site(s)" [(ngModel)]="mySitess"
                    style="overflow:auto;resize:none;height: 28px;">
                <div class="">
                    <span [ngClass]="disable ? 'nonClass' : 'enableClass'" class="fs-13 m-1  btn btn-outline-primary" *ngFor="let chip of settingObj.mySites;let i = index">
                        {{chip}}<i class=" text-secondary bi bi-x-circle-fill" style="padding-left: 5px !important;"
                            (click)="removeChip(i,'mySitess')"></i>
                    </span>
                </div>
            </div>
            <ng-template #mySites>
                <div class="d-flex align-items-center justify-content-center serp-score">
                    <p>Add your own sites. They will appear as a Blue icons and you’ll know one of your sites are ranking
                        for
                        that keyword</p>
                </div>
            </ng-template>
        </div>
        <p class="m-0 ms-3 text-light-gray"><b>Note:</b>To enter multiple domains or sites enter URLs seperated with ",".
        </p>
        <!-- <p class="m-0 ms-3">Example: "www.mydomain1.com , www.mydomain2.com" </p> -->
        <div [ngClass]="disable ? 'disableClass' : 'enableClass'" class="d-flex">
            <button [ngClass]="disable ? 'nonClass' : 'enableClass'" class="btn btn-outline-primary m-3 ms-auto" (click)="updateSettings()">Update</button>
        </div>
    </div>
</div>